export default __webpack_public_path__ + "static/media/dog-image-2.2fdd0dd4.jpeg";